<script setup lang="ts">
import {SlidersHorizontal, UsersRound} from "@lucide/vue";
import BaseButton from "@/core/components/base/BaseButton.vue";

defineEmits<{
    (event: 'filters'): void;
}>();
</script>

<template>
  <div class="flex flex-col items-center text-center gap-4">
    <div class="rounded-full bg-lightPurple-lightest p-5">
      <UsersRound class="text-primary size-10" />
    </div>
    <h2>Aucun patient ne correspond à vos critères</h2>
    <p>
      Élargissez votre audience ou retirez un filtre pour<br>afficher des patients à contacter.
    </p>
    <BaseButton primary @click="$emit('filters')">
      <SlidersHorizontal class="size-4 mr-1" />
      Modifier l'audience
    </BaseButton>
  </div>
</template>

<style scoped>

</style>
